import { render, staticRenderFns } from "./OrdersTableDetailRows.vue?vue&type=template&id=354333b6&"
import script from "./OrdersTableDetailRows.vue?vue&type=script&lang=js&"
export * from "./OrdersTableDetailRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports